export enum TunnelErrorType {
    ERROR_INVALID_ADDRESS = 'ERROR_INVALID_ADDRESS',
    WARNING_NO_STREET_NUMBER = 'WARNING_NO_STREET_NUMBER',
    INFO_SESSION_EXPIRED = 'INFO_SESSION_EXPIRED',
    WARNING_ADDRESS_NOT_RECOGNIZED = 'WARNING_ADDRESS_NOT_RECOGNIZED',
    ERROR_INVALID_PRODUCT = 'ERROR_INVALID_PRODUCT',
    ERROR_FATAL = 'ERROR_FATAL',
    WARNING_EXPIRED_PRODUCT = 'WARNING_EXPIRED_PRODUCT',
    ERROR_CREATING_CART = 'ERROR_CREATING_CART',
    INVALID_TOKEN = 'INVALID_TOKEN',
    INVALID_IBAN = 'INVALID_IBAN',
    INVALID_BILLING = 'INVALID_BILLING',
    ORDER_ALREADY_IN_PROGRESS = 'ORDER_ALREADY_IN_PROGRESS',
    LOCKED_SCORING = 'LOCKED_SCORING',
    BAD_ACCOUNT_TYPE = 'BAD_ACCOUNT_TYPE',
    ERROR_DEFAULT = 'ERROR_DEFAULT',
}

export type ErrorModalButton = {
    label: string;
    action?: () => void;
};

export type TunnelErrors = {
    [key in TunnelErrorType]: {
        title?: string;
        subtitle?: string;
        description: string;
        primaryButton?: ErrorModalButton;
        secondaryButton?: ErrorModalButton;
    };
};

export class ProductNotFoundError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ProductNotFound';
    }
}
